import { TenantType } from '../config/enums'
import { router } from '@/router'

/**
 * 登录缓存key
 */
export let userLoginSessionKey

/**
 * 设置登录缓存key
 * @param {*} value
 */
export function setUserLoginSessionKey(value) {
  userLoginSessionKey = value
}

/**
 * 获取登录缓存key
 * @param {*} value
 */
export function getUserLoginSessionKey() {
  let sisscloudtokenid = router.currentRoute.value.params.sisscloudtokenid
  // console.log('getUserLoginSessionKey---', sisscloudtokenid)
  if (!sisscloudtokenid || sisscloudtokenid == 'undefined' || sisscloudtokenid == "''") sisscloudtokenid = ''
  return sisscloudtokenid
}

/**
 * api请求类型 零售：ls/餐饮：cy
 */
export let apiType = 'ls'

/**
 * 设置api请求类型
 * @param {*} value
 */
export function setApiType(value) {
  apiType = value
}

/**
 * 获取api请求类型
 * @param {*} value
 */
export function getApiType() {
  let apiType = 'ls'
  let otherData = router.currentRoute.value.params.otherData
  // console.log('getApiType---', router.currentRoute.value)
  if (otherData) {
    otherData = JSON.parse(decodeURIComponent(otherData))
    // console.log('getApiType---', otherData)
    if (otherData && otherData.apiType) {
      apiType = otherData.apiType
    }
  }
  return apiType
}

/* 是否为星云版 */
export let isXyun = false

/**
 * 设置是否为星云版
 * @param {Boolean} value
 */
export function setIsXyun(value) {
  isXyun = value
}

// 登录用户信息
export const user = {
  TenantId: 0,
  TenantName: 'none',
  BranchCode: '',
  BranchId: 0,
  BranchName: 'none',
  OperId: 0,
  OperName: 'none',
  BranchType: '' // 门店类型：总店
  // TenantType: 14,
  // isHeadquarters: false // 是否为总部门店
}

/**
 * 设置当前用户信息
 * @param {*} data
 */
export function setCurrentUser(data) {
  Object.assign(user, data)
  user.isHeadquarters = data.TenantType === 'Z'
}

export function getTenantType() {
  if (TenantType.xyun === user.TenantType) return 'xyun'
  if (TenantType.star === user.TenantType) return 'star'
}

/**
 * 应用中西埋点类型:100
 */
export function getPointSourceType() {
  return 100
}
